import { AlertModal } from "../../components/Modals/AlertModal/AlertModal";
import { More } from "@rsuite/icons";
import BlockRoundIcon from "@rsuite/icons/BlockRound";
import CheckRoundIcon from "@rsuite/icons/CheckRound";
import UpdateRoundIcon from "@rsuite/icons/UpdateRound";
import TimeRoundIcon from "@rsuite/icons/TimeRound";
import DoingRoundIcon from "@rsuite/icons/DoingRound";
import RateIcon from "@rsuite/icons/Rate";
import React, { useEffect, useRef, useState } from "react";
import { Popover, Dropdown, IconButton, Whisper } from "rsuite";
import ViewOrderModal from "./ViewOrder";
import { useDispatch } from "react-redux";
import { setActionData } from "../../../redux/userActionData";
import { useNavigate } from "react-router-dom";
import { orderStatusObj, statusArr } from "../../../core/config/AppConstants";
import { useTranslation } from "react-i18next";
import { encryptUrl } from "../../../navigation/useDecryptParams";
import { ContentRoutes } from "../../../navigation/NavConstant";
import CancelRestoreOrder from "./CancelRestoreOrder";
import ServeOrder from "./ServeOrder";
import RateOrder from "./RateOrder";
import { isWebResolutionSize } from "../../../utils/helpers";
import RateOrderModal from "./RateOrderModal";

const OrderSingleAction = ({
  orderData,
  onDeleteOrder,
  onCancelRestoreOrder,
  onServeOrder,
  permission,
  ...props
}: {
  orderData: any;
  onDeleteOrder: Function;
  onCancelRestoreOrder: Function;
  onServeOrder: Function;
  permission: any;
}) => {
  const { t } = useTranslation();
  const orderRef = useRef({});
  const dispatch = useDispatch();
  const [openModalByName, setOpenModalByName] = useState("");
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [openCancelModal, setOpenPublishModal] = useState(false);
  const [isWebResolution, setIsWebResolution] = useState(isWebResolutionSize());
  const ecryptedOrderId = encryptUrl(`${orderData.id}`);

  const orderUpdateLink = ContentRoutes.UPDATE_ORDER.replace(
    ":id",
    ecryptedOrderId.toString(),
  );

  const orderUpdateRatingLink = ContentRoutes.UPDATE_ORDER_RATING.replace(
    ":id",
    ecryptedOrderId.toString(),
  );

  const navigate = useNavigate();
  const updateResolution = () => {
    setIsWebResolution(isWebResolutionSize());
  };

  useEffect(() => {
    window.addEventListener("resize", updateResolution);
  }, []);

  const handleEvent = (eventKey: any) => {
    setOpenModalByName(eventKey);
    dispatch(setActionData(orderData));
  };
  let cancelText =
    t("CURRENT") +
    " " +
    t("ORDER_STATUS") +
    ": " +
    orderStatusObj[orderData.order_status as keyof typeof orderStatusObj]
      .label +
    " " +
    t("DO") +
    " " +
    t("YOU").toLowerCase() +
    " " +
    t("WANT").toLowerCase() +
    " " +
    t("TO").toLowerCase() +
    " ";

  let cancelActionText =
    orderData.order_status == orderStatusObj.cancelled.value
      ? t("RESTORE")
      : t("CANCEL");
  cancelText += cancelActionText.toLowerCase();
  let cancelIcon = <CheckRoundIcon />;
  let serveText =
    t("CHANGE") +
    " " +
    orderStatusObj[orderData.order_status as keyof typeof orderStatusObj]
      .label +
    " " +
    t("STATUS");

  let serveIcon = <UpdateRoundIcon />;
  let rateIcon = <RateIcon />;

  if (orderData.order_status == orderStatusObj.pending.value) {
    cancelIcon = <TimeRoundIcon />;
  } else if (orderData.order_status == orderStatusObj.cancelled.value) {
    cancelIcon = <BlockRoundIcon />;
  } else if (orderData.order_status == orderStatusObj.inprogress.value) {
    cancelIcon = <DoingRoundIcon />;
  }

  const renderMenu = (
    {
      onClose,
      left,
      top,
      className,
    }: { onClose: any; left: any; top: any; className: any },
    ref:
      | ((instance: HTMLDivElement | null) => void)
      | React.RefObject<HTMLDivElement>
      | null
      | undefined,
  ) => {
    const handleSelect = (eventKey: any) => {
      if (eventKey == "edit-order") {
        handleEditAction();
      } else if (eventKey == "edit-order-rating") {
        handleEditRatingAction();
      } else if (eventKey == "delete-order") {
        orderRef.current = orderData;
        setOpenDeleteModal(true);
      } else if (eventKey == "cancel-restore-order") {
        handleEvent("cancel-restore-order");
      } else if (eventKey == "serve-order") {
        handleEvent("serve-order");
      } else if (eventKey == "rate-order") {
        handleEvent("rate-order");
      } else {
        setOpenModalByName(eventKey);
        dispatch(setActionData(orderData));
      }
      onClose();
    };
    return (
      <Popover ref={ref} className={className} style={{ left, top }} full>
        <Dropdown.Menu onSelect={handleSelect}>
          <Dropdown.Item eventKey={"view-order"}>{t("VIEW")}</Dropdown.Item>
          {permission.update && (
            <Dropdown.Item eventKey={"edit-order"}>{t("EDIT")}</Dropdown.Item>
          )}
          {permission.update && (
            <Dropdown.Item eventKey={"edit-order-rating"}>
              {t("EDIT")} {t("RATING")}
            </Dropdown.Item>
          )}
          {permission.delete && (
            <Dropdown.Item eventKey={"delete-order"}>
              {t("DELETE")}
            </Dropdown.Item>
          )}
          {!isWebResolution && (
            <>
              {permission.cancel_restore && (
                <Dropdown.Item eventKey={"cancel-restore-order"}>
                  {cancelActionText + " " + t("ORDER")}
                </Dropdown.Item>
              )}
              {permission.serve && (
                <Dropdown.Item eventKey={"serve-order"}>
                  {serveText}
                </Dropdown.Item>
              )}
              {permission.service_rating && (
                <Dropdown.Item eventKey={"rate-order"}>
                  {t("RATE") + " " + t("ORDER")}
                </Dropdown.Item>
              )}
            </>
          )}
        </Dropdown.Menu>
      </Popover>
    );
  };

  function handleEditAction() {
    navigate(`${orderUpdateLink}`);
  }

  function handleEditRatingAction() {
    console.log(`${orderUpdateRatingLink}`);
    navigate(`${orderUpdateRatingLink}`);
  }

  return (
    <div>
      {isWebResolution && (
        <>
          {permission.cancel_restore && (
            <>
              <IconButton
                onClick={() => {
                  handleEvent("cancel-restore-order");
                }}
                icon={cancelIcon}
                title={cancelText}
                size="md"
              />
            </>
          )}
          {permission.serve && (
            <>
              <IconButton
                onClick={() => {
                  handleEvent("serve-order");
                }}
                icon={serveIcon}
                title={serveText}
                size="md"
              />
            </>
          )}
          {permission.service_rating && (
            <>
              <IconButton
                onClick={() => {
                  handleEvent("rate-order");
                }}
                icon={rateIcon}
                title={t("CUSTOMER") + " " + t("RATING")}
                size="md"
              />
            </>
          )}
        </>
      )}

      <Whisper
        placement="topEnd"
        trigger="click"
        speaker={renderMenu}
        preventOverflow={true}
      >
        <IconButton appearance="subtle" icon={<More />} />
      </Whisper>
      {openModalByName === "view-order" && (
        <ViewOrderModal
          status={openModalByName === "view-order" ? true : false}
          toggle={setOpenModalByName}
        />
      )}
      {openModalByName === "cancel-restore-order" && (
        <CancelRestoreOrder
          openModal={openModalByName === "cancel-restore-order" ? true : false}
          setOpenModal={setOpenModalByName}
          orderObj={orderData}
          onCancelRestoreOrder={onCancelRestoreOrder}
        />
      )}
      {openModalByName === "serve-order" && (
        <ServeOrder
          openModal={openModalByName === "serve-order" ? true : false}
          setOpenModal={setOpenModalByName}
          orderObj={orderData}
          onServeOrder={onServeOrder}
        />
      )}
      {openModalByName === "rate-order" && (
        <RateOrderModal
          openModal={openModalByName === "rate-order" ? true : false}
          setOpenModal={setOpenModalByName}
          orderId={orderData.id}
          onServeOrder={onServeOrder}
          permission={permission}
        />
      )}
      <AlertModal
        open={openDeleteModal}
        handleClose={(e: any) => {
          if (e == true) {
            onDeleteOrder(orderRef);
            setOpenDeleteModal(false);
          } else {
            setOpenDeleteModal(false);
          }
        }}
        displayText={t("CONFIRM_ACTION", {
          action: t("DELETE").toLowerCase(),
          entity: t("ORDER").toLowerCase(),
        })}
        modalTitle={t("CONFIRM_ACTION_TITLE", {
          action: t("DELETE").toLowerCase(),
        })}
      />
    </div>
  );
};

export default OrderSingleAction;
